module.exports = __webpack_public_path__ + "img/2.484455a1.jpg";